import styled from 'styled-components';

export const FieldInputTitle = styled.div`
  color: ${(props) => props.theme.colors.muted};
`;

export const FullWideContentBlock = styled.div`
  width: 100%;
`;

export const InputSubLabel = styled.p`
  font-size: 12px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.muted};
`;

export const InputSubLabelCompact = styled(InputSubLabel)`
  ${(props) => props.theme.typography.notification}
`;

export const ExtraFieldLink = styled.a`
  ${(props) => props.theme.typography.description}
  color: ${(props) => props.theme.colors.brand};
  text-decoration: none;
  :hover {
    opacity: 0.9;
  }
`;
